module.exports = __webpack_public_path__ + "img/csv-icon.c28f596a.svg";